import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  deleteInvite: {
    id: 'studio.HiwFxD',
    defaultMessage: 'Delete invite',
  },
  cancelLabel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  deleteConfirmationBody: {
    id: 'studio.ElMX/X',
    defaultMessage: 'Are you sure you want to remove this invite?',
  },
  deleteSuccess: {
    id: 'studio.d1MeYT',
    defaultMessage: 'The invite has been deleted successfully',
  },
  resend: {
    id: 'studio.yQqaoM',
    defaultMessage: 'Resend invite',
  },
  resendSuccess: {
    id: 'studio.F+aPGZ',
    defaultMessage: 'The invite has been resent successfully',
  },
  resendError: {
    id: 'studio.Ozo2xR',
    defaultMessage: 'There was a problem sending the invite. Please retry later.',
  },
  invited: {
    id: 'studio.qJje/s',
    defaultMessage: 'Invited',
  },
});
